<template>
  <div>
    <!--account settings-->
    <div class="settings__account--personal">
      <div class="panel">
        <div class="panel__header">
          <div class="panel__header__left">
            Account <span>settings</span>
          </div>
        </div>
        <div class="panel__content panel__content--grey">
          <div class="settings__form-container">
            <form action="" class="form--flex-items">
            
              <div class="form__item">
                <label  class="inline">Home <span>country</span></label>
                <div class="form__item__input">
                   <span class="form__icon icon--sm">
                      <svg  xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0" y="0" viewBox="0 0 512 512" xml:space="preserve" enable-background="new 0 0 512 512">
                          <g transform="matrix(1.25 0 0 -1.25 0 45)">
                          <path d="M45.51-20.89C20.38-20.89 0-41.27 0-66.4v-204.8c0-25.13 20.38-45.51 45.51-45.51h91.02v295.82H45.51z" fill="#009A49"/>
                          <path d="M136.53-316.71h136.53v295.82H136.53V-316.71z" fill="#EEE"/>
                          <path d="M364.09-20.89h-91.02v-295.82h91.02c25.13 0 45.51 20.38 45.51 45.51v204.8C409.6-41.27 389.22-20.89 364.09-20.89" fill="#009A49"/>
                        </g>
                      </svg>
                   </span>
                  <input type="text" class="form__input has--left-icon" v-model="userDetails.country">
                  <span class="other-options__trigger">Change</span>
                </div>
              </div>
            
              <div class="form__item">
                <label  class="inline">Primary  <span>currency</span></label>
                <div class="select">
                  <select name="" id="" class="form__input select__input has--left-icon">
                    <option value="">Naira (NGN)</option>
                    <option value="">Dollars (USD)</option>
                    <option value="">Kenya Shillings (KSh)</option>
                    <option value="">Ghana Cedis (GH)</option>
                    <option value="">Rand (Rd)</option>
                  </select>
                  <div class="select__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill="#42476f" fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path></svg>
                  </div>
                </div>
              </div>
            
              <div class="form__item">
                <label  class="inline">Preferred  <span>timezone</span></label>
                <div class="select">
                  <select name="" id="" class="form__input select__input has--left-icon">
                    <option value="">CET/CEST - Denmark</option>
                    <option value="">GMT+1</option>
                  </select>
                  <div class="select__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill="#42476f" fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path></svg>
                  </div>
                </div>
              </div>
            
              <div class="form__item">
                <label  class="inline">Trading <span>as a </span></label>
                <div class="form__item__input">
                  <input type="text" class="form__input has--left-icon">
                  <span class="other-options__trigger">Change</span>
                </div>
              </div>
            
              <div class="form__item">
                <label  class="inline">Trader</label>
                <div class="form__item__input--half">
                  <input type="text" class="form__input" placeholder="Koromone">
                </div>
                <div class="form__item__input--half">
                  <input type="text" class="form__input" placeholder="Baker">
                </div>
              </div>
            
              <div class="form__item">
                <label  class="inline">Trading <span>name</span></label>
                <div class="form__item__input">
                  <input type="text" class="form__input form__input--shadowed" placeholder="Koromone">
                </div>
              </div>
            </form>
          </div>
        </div>
      
        <div class="panel__footer align-end">
          <div class="panel__footer__right">
            <button class="btn btn--default">Cancel</button>
            <button class="btn btn--primary">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  
    <!--business settings-->
    <div class="settings__account--business">
      <div class="panel">
        <div class="panel__header">
          <div class="panel__header__left">
            Business <span>Information</span></div>
        </div>
        <div class="panel__content panel__content--grey">
          <div class="settings__form-container">
            <form action="" class="form--flex-items">
            
              <div class="form__item">
                <label  class="inline">Primary <span>website</span></label>
                <div class="form__item__input">
                  <input type="text" class="form__input" v-model="userDetails.website">
                </div>
              </div>
  
              <div class="form__item">
                <label  class="inline">Phone <span>number</span></label>
                <div class="form__item__input">
                  <input type="text" class="form__input" v-model="userDetails.phone">
                </div>
              </div>
              
            
              <div class="form__item">
                <label  class="inline">Support <span>email</span></label>
                <div class="form__item__input">
                  <input type="text" class="form__input" v-model="userDetails.websiteTwo">
                </div>
            
              </div>
              
              <div class="form__item--group">
                <div class="form__item">
                  <label  class="inline">Business <span>address</span></label>
                  <div class="form__item__input">
                    <input type="text" class="form__input" v-model="userDetails.websiteTwo">
                  </div>
                </div>
  
                <div class="form__item">
                  <label  class="inline invisible">City and region</label>
                  <div class="form__item__input--half">
                    <input type="text" class="form__input" placeholder="Lekki Phase 1">
                  </div>
                  <div class="form__item__input--half">
                    <input type="text" class="form__input" placeholder="Lagos state">
                  </div>
                </div>
  
                <div class="form__item">
                  <label  class="inline invisible">Zipcode and Country</label>
                  <div class="form__item__input--half">
                    <input type="text" class="form__input" placeholder="123456">
                  </div>
                  <div class="form__item__input--half">
                    <input type="text" class="form__input has--left-icon" placeholder="Nigeria">
                    <span class="form__icon icon--sm">
                      <svg  xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0" y="0" viewBox="0 0 512 512" xml:space="preserve" enable-background="new 0 0 512 512">
                          <g transform="matrix(1.25 0 0 -1.25 0 45)">
                          <path d="M45.51-20.89C20.38-20.89 0-41.27 0-66.4v-204.8c0-25.13 20.38-45.51 45.51-45.51h91.02v295.82H45.51z" fill="#009A49"/>
                          <path d="M136.53-316.71h136.53v295.82H136.53V-316.71z" fill="#EEE"/>
                          <path d="M364.09-20.89h-91.02v-295.82h91.02c25.13 0 45.51 20.38 45.51 45.51v204.8C409.6-41.27 389.22-20.89 364.09-20.89" fill="#009A49"/>
                        </g>
                      </svg>
                  </span>
                  </div>
                </div>
              </div>
             
            </form>
          </div>
        </div>
      
        <div class="panel__footer align-end">
          <div class="panel__footer__right">
            <button class="btn btn--default">Cancel</button>
            <button class="btn btn--primary">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
 
  

</template>

<script>
  export default {
    
    data() {
      return {
        userDetails: {
          country:'Nigeria'
        },
      }
    },
    
    components:{
    
    },
    methods:{
    
    }
  }
</script>

<style lang="scss" scoped>
  .panel__footer__right{
    .btn--default{
      margin-right:8px;
    }
  }
  .select__icon{
    top:12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/GeneralSettings.vue